import { useEffect, useRef, useState } from "react";
import { useAuth } from "../auth/AuthContext";

export function AuthCallbackPage() {
  const { completeWechatLogin } = useAuth();
  const [error, setError] = useState<string | null>(null);
  // 严格模式双调用保护：回调只能消费一次
  const consumed = useRef(false);

  useEffect(() => {
    if (consumed.current) return;
    consumed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (!code || !state) {
      setError("回调参数缺失（code / state）");
      return;
    }

    void completeWechatLogin({ code, state })
      .then(() => {
        // 登录态写入 AuthContext 后 App 会自动渲染主界面；
        // 清掉 URL 中的回调参数，避免刷新时重复消费
        window.history.replaceState({}, "", "/");
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : "登录失败，请重试");
      });
  }, [completeWechatLogin]);

  if (error) {
    return (
      <div className="login-page">
      <div className="login-card centered">
        <h1>登录失败</h1>
        <div className="login-error mt-16">
          {error}
        </div>
        <button className="login-btn mt-20" onClick={() => window.location.replace("/")}>
          返回登录页
        </button>
      </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card centered">
        <h1>正在登录…</h1>
        <div className="sub mt-12">
          <span className="spinner" />
          正在与企业微信交换身份
        </div>
      </div>
    </div>
  );
}
